

import './offers-wrapper.scss';

import debounce from 'lodash.debounce';
import { getCurrentZipcode } from '../../core/selectors/zipcode';
import { getCurrentOffer } from '../../core/selectors/offers';
import { getAllVehicles, getSelectedVehicle } from '../../core/selectors/vehicles';
import { openOfferDetails } from '../../core/actions/offers';
import { queryParamsLoaded, loadData } from '../../core/actions/data';
import { checkDefaultVehicle } from '../../core/actions/vehicles';
import {
      BASE_URL,
      OFFERID_QUERY_PARAM,
      TABID_QUERY_PARAM,
      DEALERID_QUERY_PARAM,
      OFFER_SORT_QUERY_PARAM,
      VEHICLE_QUERY_PARAM,
      INTERPOLATION_REGEX,
      MEDIAQUERY_XSMALL,
      MEDIAQUERY_SMALL,
      MEDIAQUERY_MEDIUM,
      MEDIAQUERY_LARGE,
      MEDIAQUERY_XLARGE,
    } from '../../core/constants';
import { SORT_OPTIONS, OFFERS } from '../../core/selectors/constants';
import { findParam } from '../../core/queryParams';
import checkBackground from '../../core/helpers/responsive-background';
import { getOfferTerm, getMonthsBetween } from '../../core/helpers/offers';
riot.tag2('offers-wrapper', '<yield></yield>', '', 'class="{opts.theme}{promo ? \' is-promo\' : \'\'}{ready ? \' is-ready\' : \'\'}" riot-style="background-image: url(\'{backgroundImage}\');"', function(opts) {
    /* global Acr */

    var utility = window.Utility;

    const notification = require('../../core/actions/notification').default;

    const self = this;

    const trackingJSON = require('../../data/tracking-data');

    let trackingPageloadTriggered = false;

    self.trackingData = trackingJSON.default.getThisOffer;
    self.mixin('bus');
    self.mixin('redux');

    self.dispatchify({ openOfferDetails });
    self.dispatchify({ queryParamsLoaded });
    self.dispatchify({ checkDefaultVehicle });
    self.dispatchify({ loadData });

    self.subscribe(getCurrentZipcode);
    self.subscribe(getCurrentOffer);
    self.subscribe(getSelectedVehicle);
    self.subscribe(getAllVehicles);

    window.Acr = window.Acr ? window.Acr : {};

    function handleCta(data) {
      let cookieZipcode = '';
      if (data.event.item.link.modal) {
        cookieZipcode = localStorage.getItem('userZipCode');

        if (cookieZipcode) {
          if (self.config && self.config.enableModal) {
            self.bus.trigger(self.bus.EVENTS.MODAL.MODAL_OPEN, {
              url: data.ctaObj.href,
            });
          } else {
            window.open(data.ctaObj.href, data.ctaObj.target);
          }
        } else {
          Acr.zipgateComponent.openZipgate(handleCta, data);
        }
      } else {
        window.open(data.ctaObj.href, data.ctaObj.target);
      }
    }

    function goToOffer() {
      const queryOfferid = findParam(OFFERID_QUERY_PARAM);
      const bestOfferQuery = findParam(OFFER_SORT_QUERY_PARAM);
      const vehicleModelSeries = findParam(VEHICLE_QUERY_PARAM);
      let $offer = '';
      let top = '';

      if (queryOfferid) {
        const offerSelector = `platform-offer-card[id^="offer_${queryOfferid}"]`;
        $offer = document.querySelector(offerSelector);
        const tabs = document.querySelectorAll('tab-panel');
        let tabNumber = 0;

        if ($offer) {
          self.openOfferDetails({ offerId: $offer.id.split('_')[1] });
          self.queryParamsLoaded({
            defaultModelGroup: self.currentOffer.ModelGroupName,
          });
          self.checkDefaultVehicle();
          self.bus.trigger(self.bus.EVENTS.MODEL.CHANGE, {
            newValue: self.currentOffer.ModelGroupName,
          });

          // After opening details, check which tab it was opened
          for (let i = 0; i < tabs.length; i++) {
            if (tabs[i].querySelector(offerSelector)) {
              tabNumber = i + 1;
              break;
            }
          }
          // Selecting found tab
          document.querySelector(`tab:nth-child(${tabNumber})`).click();

          $offer = document.querySelector(offerSelector);
          top = $offer.getBoundingClientRect().top;

          // SCrolling to the top of the offer
          window.scrollTo(0, top);

          self.bus.trigger(self.bus.EVENTS.OFFER_CARD.LINK_CLICK, {
            event: {
              item: {
                offer: self.currentOffer,
              },
            },
            id: $offer.id,
          });
        }
      }

      if (bestOfferQuery
        && SORT_OPTIONS.indexOf(bestOfferQuery.toLowerCase()) !== -1
        && vehicleModelSeries) {
        const bestOfferSelector = 'tab-panel.is-active offers-container platform-offer-card';

        $offer = document.querySelector(bestOfferSelector);

        self.openOfferDetails({ offerId: $offer.id.split('_')[1] });

        self.bus.trigger(self.bus.EVENTS.OFFER_CARD.LINK_CLICK, {
          event: {
            item: {
              offer: self.currentOffer,
            },
          },
          id: $offer.id,
        });
      }
    }

    function goToTab() {
      const queryTabId = findParam(TABID_QUERY_PARAM);
      let $tab;

      if (queryTabId) {
        const tabSelector = `[data-tab-id='${queryTabId}']`;
        $tab = document.querySelector(tabSelector);
        if ($tab) {
          $tab.click();
          if (Acr && Acr.Deeplinking) {
            Acr.Deeplinking.inPageDeeplink('tabs-content');
          }
        }
      }
    }

    function getText(url, offer) {
      const replacements = url.match(INTERPOLATION_REGEX);

      if (replacements) {
        replacements.forEach((match) => {
          url = url.replace(match, offer[match.slice(3, -3).toLowerCase()] || '');
        });
      }

      return url;
    }

    function getTrackingData(offer) {
      const jsonData = JSON.parse(JSON.stringify(self.trackingData));
      jsonData.Offer.offer_type = offer.type;
      jsonData.Model = {
        model_name: offer.ModelGroupName,
        model_year: offer.ModelYear ? offer.ModelYear.toString() : '',
      };
      jsonData.Offer.offer_amount = offer.payment;
      jsonData.Offer.offer_name = offer.SalesProgramName;
      jsonData.Offer.offer_date = `${offer.StartDate} | ${offer.EndDate}`;
      jsonData.Offer.offer_model = offer.ModelGroupName;
      jsonData.Offer.offer_model_year = offer.ModelYear ? offer.ModelYear.toString() : '';
      jsonData.Offer.offer_duration = getMonthsBetween(offer.StartDate, offer.EndDate);
      jsonData.Offer.offer_term = getOfferTerm(offer);
      jsonData.Offer.offer_expire = offer.EndDate;
      jsonData.Offer.offer_start = offer.StartDate;
      jsonData.Offer.offer_id = offer.Id;
      jsonData.dynamic_variables[0].search += `${jsonData.Offer.offer_name} get this offer`;
      if (Acr.TrackingManager) {
        Acr.TrackingManager.clickActivity(jsonData);
      }
    }

    function buttonClickHandler(data) {
      const cta = data.event.item.offer.SalesProgramType === OFFERS.TYPES.HCPV
        ? self.getLabel('ctas.specialOfferDetailsLInks')[1] : self.getLabel('ctas.offerCardRAQ')[0];
      data.event.item.offer.modal = cta.modal;
      const vehicleModel = self.vehicle ? self.vehicle.model : '';
      const vehicleYear = self.vehicle ? self.vehicle.year : '';
      getTrackingData(data.event.item.offer);

      if (!cta) {
        return;
      }

      const params = {
        modelgroupname: vehicleModel || data.event.item.offer.ModelGroupName,
        modelgroupnamewithhypens: data.event.item.offer.ModelGroupName.toLowerCase().replace(' ', '-'),
        modelgroupnamewithspaces: data.event.item.offer.ModelGroupName.toLowerCase(),
        offerid: data.event.item.offer.Id,
        modelid: data.event.item.offer.ModelId,
        modelyear: data.event.item.offer.ModelYear || vehicleYear,
        zipcode: self.zipcode,
        dealerid: findParam(DEALERID_QUERY_PARAM),
      };

      // Add a custom event to connect Riot's Inventory app with React's RAQ app
      const reactRAQConfiguration = {
        modelId: params.modelid,
        offers: [params.offerid]
      };
      const reactRAQEvent = utility.createEvent('react-raq-open', reactRAQConfiguration);
      window.dispatchEvent(reactRAQEvent);

    }

    function handleSpecialOfferDetail(data) {
      if (self.config && self.config.enableModal) {
        document.querySelector('html').classList.add('no-scroll');

        const specificToModel = data.offer.ModelGroupName && data.offer.ModelYear;
        const attribute = specificToModel
          ? `${data.offer.ModelGroupName}:${data.offer.ModelYear}:${data.offer.SalesProgramType}`
          : 'no model:no model year:special-program-offer';
        const modelName = self.vehicle && self.vehicle.model ? self.vehicle.model : data.offer.ModelGroupName;
        const modelYear = data.offer.ModelYear || (self.vehicle && self.vehicle.year ? self.vehicle.year : '');
        const nameYearParams = data.url.indexOf('?') >= 0
          ? `&vehiclemodelseries=${modelName}&modelYear=${modelYear}`
          : `?vehiclemodelseries=${modelName}&modelYear=${modelYear}`;
        const url = data.url + nameYearParams;

        self.bus.trigger(self.bus.EVENTS.MODAL.MODAL_OPEN, {
          url,
          event: data.event,
        });
      }
    }

    function handleModalClose() {
      document.querySelector('html').classList.remove('no-scroll');
    }

    function resizeValidation() {
      self.bus.trigger(self.bus.EVENTS.APP.RESIZE);
    }

    function refreshWrapper() {
      self.update();
    }

    function trackingPageManager(offersZipcode) {
      trackingPageloadTriggered = true;
      const QSModelParam = findParam(VEHICLE_QUERY_PARAM);
      let model = 'All Vehicles';

      if (QSModelParam) {
        model = self.vehicles.reduce((value, item) => {
          if (item.model.toLowerCase() === QSModelParam.toLowerCase()) {
            return QSModelParam.toLowerCase();
          }
          return value;
        }, model);
      }

      const dataObject = {
        Model: {
          model_name: model,
          model_year: 'no model',
        },
        Page: {
          site_section: 'shopping tools',
          sub_section: 'current offers',
          sub_section2: 'current offers results',
          page_name: 'current offers',
        },
        Offer: {
          current_offers_zip_code: offersZipcode || '',
        },
        'Event Metadata': {
          tms_event: 'offers_view',
        },
      };
      if (Acr.TrackingManager) {
        Acr.TrackingManager.pageLoad(dataObject);
      } else {
        // this event will be triggered once that
        // TrackingManager.js is loaded. Used to avoid dependencies issues.
        window.addEventListener('trackingPageload', () => {
          if (Acr.TrackingManager) {
            Acr.TrackingManager.pageLoad(dataObject);
          }
        });
      }
    }

    self.bus.on(self.bus.EVENTS.MODAL.MODAL_IS_CLOSING, handleModalClose);
    self.bus.on(self.bus.EVENTS.CARD.VIEW_SPECIAL_OFFER_DETAIL, handleSpecialOfferDetail);
    self.bus.on(self.bus.EVENTS.CTA.CLICK, handleCta);
    self.bus.on(self.bus.EVENTS.DATA.DATA_LOADED, () => {
      setTimeout(goToOffer, 500);
      // TODO: Talk to chio about avoiding this
      // There was an issue the first time the data is loaded, no payment is shown for special offers
      setTimeout(refreshWrapper, 500);
    });

    self.bus.on(self.bus.EVENTS.DATA.DATA_LOADED, goToTab);
    self.bus.on(self.bus.EVENTS.OFFER_CARD.BUTTON_CLICK, buttonClickHandler);
    self.bus.on(self.bus.EVENTS.ZIPGATE.CLOSE, () => {
      if (!trackingPageloadTriggered) {
        trackingPageManager();
      }
    });
    self.on('mount', () => {
      const endpoint = self.getLabel('offersAPIBaseURL');
      self.ready = true;
      let url = `${BASE_URL}${endpoint}`;
      const callback = () => {
        this.bus.trigger(this.bus.EVENTS.DATA.DATA_LOADED);
      };

      if (!self.zipcode) {
        self.loadData(url, callback);
      } else {
        let connector = '?';
        if (endpoint.match(/(\?)/)) {
          connector = '&';
        }
        url = self.zipcode ? `${BASE_URL}${endpoint}${connector}zipCode=${self.zipcode}` : `${BASE_URL}${endpoint}`;
        self.loadData(url, callback);
      }

      // Responsive promo background:start
      const breakpoints = [
        {
          matchMedia: window.matchMedia(MEDIAQUERY_XSMALL),
          parameter: 'OffersBackgroundXSmall',
        },
        {
          matchMedia: window.matchMedia(MEDIAQUERY_SMALL),
          parameter: 'OffersBackgroundSmall',
        },
        {
          matchMedia: window.matchMedia(MEDIAQUERY_MEDIUM),
          parameter: 'OffersBackgroundMedium',
        },
        {
          matchMedia: window.matchMedia(MEDIAQUERY_LARGE),
          parameter: 'OffersBackgroundLarge',
        },
        {
          matchMedia: window.matchMedia(MEDIAQUERY_XLARGE),
          parameter: 'OffersBackgroundXLarge',
        },
      ];

      checkBackground({
        callback: (imageUrl) => {
          self.backgroundImage = imageUrl;

          if (imageUrl) {
            self.promo = true;
          } else {
            self.promo = false;
          }

          self.update();
        },
        startDate: self.getLabel('promotional.StartDate'),
        endDate: self.getLabel('promotional.EndDate'),
        data: self.getLabel('promotional'),
        breakpoints,
      });

      // Responsive promo background:end

      self.bus.trigger(self.bus.EVENTS.APP.MOUNT, {});

      // analytics digital data
      window.digitalData = {
        page: {
          pageName: 'CURRENT OFFERS',
          channel: 'SHOPPING TOOLS',
        },
      };
      notification();
    });

    self.on('update', () => {
      if (self.vehicles.length > 0) {
        if (!trackingPageloadTriggered) {
          trackingPageManager(self.zipcode);
        }
      }
    });

    window.addEventListener('resize', debounce(resizeValidation, 300));
});
